import { SignedIn, SignedOut } from "@clerk/clerk-react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AgentShell } from "./layout/AgentShell";
import { AgentActivity } from "./pages/AgentActivity";
import { AgentHome } from "./pages/AgentHome";
import { AgentLanding } from "./pages/AgentLanding";
import { AgentSignUpPage } from "./pages/AgentSignUpPage";

export default function App() {
  return (
    <BrowserRouter>
      <SignedOut>
        <Routes>
          <Route path="/sign-up/*" element={<AgentSignUpPage />} />
          <Route path="*" element={<AgentLanding />} />
        </Routes>
      </SignedOut>
      <SignedIn>
        <Routes>
          <Route element={<AgentShell />}>
            <Route path="/" element={<AgentHome />} />
            <Route path="/activity" element={<AgentActivity />} />
            <Route path="/sign-in" element={<Navigate to="/" replace />} />
            <Route path="/sign-up" element={<Navigate to="/" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </SignedIn>
    </BrowserRouter>
  );
}
